// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"3ac95732","131":"828b400b","232":"bf35ec56","383":"bf35ec56","620":"62f0fb0d"}[chunkId] + ".chunk.css";
};